import { useDatabase, useDatabaseVal, useList } from '../api/firebaseHooks';
import { auth } from '../api/firebase';
import { getSchoolYearPackageCatalogStartAt } from '../../functions/src/api/dates';
import { MODEL_COMPLEX_PATH, PACKAGES_PATH, studentsPath, userPackagesActive } from '../../functions/src/admin/paths';
import { ModelComplexity } from '../types';
import { PACKAGE_STATUS_COMPLETED } from '../../functions/src/api/constants';

export function useNavigationVisibility() {
    const { uid } = auth.currentUser;
    
    const [modelConstants] = useDatabaseVal<ModelComplexity>(MODEL_COMPLEX_PATH);
    
    // Check if user has children (students)
    const students = useDatabase(studentsPath(uid));
    const studentsList = useList(students);
    const numChildren = studentsList?.filter(student => !!student.val()?.student)?.length || 0;

    // Check if there are packages with staff pricing
    const mealPackages =
        useDatabase(PACKAGES_PATH, (ref) => ref.orderByChild('start').startAt(getSchoolYearPackageCatalogStartAt())) || null;
    const packagesList = useList(mealPackages);
    const hasPackagesWithStaffPrice = packagesList?.some(pkg => typeof pkg.child('priceStaff').val() === 'number');
    const hasCatalogPackages = (packagesList?.length ?? 0) > 0;

    // Check if current user has any completed packages
    const userPackages = useDatabase(userPackagesActive(uid) || null);
    const userPackagesList = useList(userPackages)?.filter(l => l.child('status').val() === PACKAGE_STATUS_COMPLETED) || [];
    const hasUserPackages = userPackagesList.length > 0;

    // Determine if packages tab should be shown
    const shouldShowPackages =
        (modelConstants?.allowPackages && (numChildren > 0 || hasPackagesWithStaffPrice || hasCatalogPackages || hasUserPackages))
        || !!modelConstants?.packagesOnly;

    // Determine if monthly menu should be shown
    const shouldShowMonthlyMenu = modelConstants?.allowMeals;

    // Determine if order tab should be shown
    // In packages only mode, only show if user has packages
    const shouldShowOrder = !modelConstants?.packagesOnly || hasUserPackages;

    return {
        shouldShowPackages,
        shouldShowMonthlyMenu,
        shouldShowOrder,
        modelConstants,
        numChildren,
        hasPackagesWithStaffPrice,
        hasCatalogPackages,
        hasUserPackages,
    };
}
